import { Link } from 'react-router-dom';

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Shared shell for legal/informational content pages rendered inside
 * PlatformLayout (light theme). Provides typographic styling for the
 * transcribed document body without relying on @tailwindcss/typography.
 */
const PROSE_CLASSES = [
  'mt-8 text-[15px] leading-relaxed text-neutral-700',
  '[&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-neutral-900',
  '[&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-neutral-900',
  '[&_p]:my-3',
  '[&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-6',
  '[&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-6',
  '[&_li]:my-1',
  '[&_a]:text-brand-teal [&_a]:underline',
  '[&_strong]:font-semibold [&_strong]:text-neutral-900',
  '[&_hr]:my-8 [&_hr]:border-neutral-200',
  '[&_table]:my-4 [&_table]:w-full [&_table]:border-collapse [&_table]:text-sm',
  '[&_th]:border [&_th]:border-neutral-200 [&_th]:bg-neutral-50 [&_th]:p-2 [&_th]:text-left',
  '[&_td]:border [&_td]:border-neutral-200 [&_td]:p-2 [&_td]:align-top',
].join(' ');

export function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  return (
    <div className="text-neutral-800">
      <section className="px-4 py-10">
        <div className="mx-auto max-w-3xl rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm md:p-10">
          <h1 className="text-3xl font-bold text-neutral-900">{title}</h1>
          <div className={PROSE_CLASSES}>{children}</div>
          <div className="mt-10 border-t border-neutral-200 pt-6">
            <Link to="/" className="text-sm font-medium text-brand-teal hover:underline">
              ← Torna alla home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
